import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question: "Why is staff augmentation important for businesses?",
    answer: `<p>Staff augmentation is crucial for businesses as it provides access to specialized skills and expertise without the long-term commitment of hiring full-time employees. This flexibility allows businesses to adapt quickly to changing project requirements and market demands, ensuring optimal resource utilization and cost-effectiveness.</p>`,
  },
  {
    question: "Who typically needs staff augmentation services?",
    answer: `<p>A wide range of businesses, including startups, SMEs, and large enterprises across various industries such as IT, software development, engineering, healthcare, finance, and more, utilize staff augmentation services. Any organization needing additional resources for short-term projects or specialized tasks can benefit from this model.</p>`,
  },
  {
    question: "What sets staff augmentation solutions apart from outsourcing?",
    answer: `<p>Staff augmentation involves hiring additional resources (developers, designers, analysts, etc.) to work alongside your existing team on-site or remotely. In contrast, outsourcing involves contracting an external company or team to complete specific tasks or projects remotely, often with limited direct interaction with your in-house team.</p>`,
  },
  {
    question:
      "Is there a distinction between staff augmentation and outstaffing?",
    answer: `<p>Yes, there is a distinction between staff augmentation and outstaffing. Staff augmentation involves integrating external resources into your existing team to work on-site or remotely under your supervision and management. Outstaffing refers to hiring dedicated resources (developers, designers, etc.) who work exclusively for your project but are managed by the outstaffing provider.</p>`,
  },
  {
    question:
      "What are the benefits of staff augmentation services for businesses?",
    answer: `<p>The benefits of staff augmentation include access to specialized skills, scalability to meet project demands, cost-effectiveness compared to hiring full-time employees, reduced recruitment time, enhanced productivity, and risk mitigation in talent shortages or skill gaps.</p>`,
  },
  {
    question: "How does the staff augmentation process work?",
    answer: `<p>The staff augmentation process typically involves identifying project requirements and skill gaps, selecting suitable external resources, onboarding and integrating them into the existing team, supervising their performance, and ensuring regular communication and feedback for alignment and success.</p>`,
  },
  {
    question:
      "What criteria should businesses consider when choosing a staff augmentation services provider?",
    answer: `<p>When choosing a staff augmentation provider, businesses should consider factors such as the provider's track record and experience, the quality of their talent pool, flexibility in engagement models, communication capabilities, transparent pricing, and client testimonials to assess credibility and satisfaction levels.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#F8F8FB" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>IT Staff Augmentation FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
